export const C = {
  coral: "#009689",
  coralLight: "#e0f2f1",
  coralDark: "#007a70",
  blue: "#667EEA",
  blueLight: "#EEF0FF",
  green: "#2ECC71",
  greenLight: "#E8FBF0",
  orange: "#F7971E",
  orangeLight: "#FFF8EC",
  purple: "#9B59B6",
  purpleLight: "#F5ECFF",
  text: "#1E293B",
  textMed: "#64748B",
  textLight: "#94A3B8",
  border: "#E2E8F0",
  borderLight: "#F1F5F9",
  bg: "#F8FAFC",
  white: "#FFFFFF",
  shadow: "0 1px 3px rgba(15,23,42,0.04), 0 1px 2px rgba(15,23,42,0.06)",
  shadowMd: "0 4px 6px -1px rgba(15,23,42,0.07), 0 2px 4px rgba(15,23,42,0.04)",
  shadowLg: "0 10px 15px -3px rgba(15,23,42,0.08), 0 4px 6px rgba(15,23,42,0.04)",
};

// ─── Filter bar pieces (same look as StepPickupAnalyticsPage / ProductPerformancePage) ─
export const fieldLabel = { fontSize: 11, fontWeight: 600, color: C.textLight, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 };
export const dateInput = { padding: "7px 10px", borderRadius: 8, border: `1.5px solid ${C.border}`, fontSize: 12, fontFamily: "inherit", outline: "none", color: C.text };

// react-select theme for report filters.
export const selectStyles = {
  control: (base, state) => ({
    ...base, minHeight: 36, borderRadius: 10, borderColor: state.isFocused ? C.coral : C.border,
    boxShadow: state.isFocused ? `0 0 0 1px ${C.coral}` : "none", fontSize: 13, fontFamily: "inherit",
    "&:hover": { borderColor: C.coral },
  }),
  option: (base, state) => ({
    ...base, fontSize: 13, padding: "8px 12px",
    backgroundColor: state.isSelected ? C.coralLight : state.isFocused ? "#f0fdfa" : "white",
    color: state.isSelected ? C.coral : C.text,
  }),
  multiValue: (base) => ({ ...base, borderRadius: 6, background: C.coralLight }),
  multiValueLabel: (base) => ({ ...base, color: C.coral, fontWeight: 600, fontSize: 12 }),
  multiValueRemove: (base) => ({ ...base, color: C.coral, ":hover": { background: C.coral, color: "white" } }),
  placeholder: (base) => ({ ...base, color: C.textLight, fontSize: 13 }),
  menu: (base) => ({ ...base, borderRadius: 10, boxShadow: C.shadowMd, zIndex: 9999 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const PIE_COLORS =["#2ECC71", "#F7971E", "#009689", "#667EEA", "#9B59B6", "#1ABC9C"];
export const CHART_LINE = ["#009689", "#667EEA", "#2ECC71", "#F7971E"];

export const tbl = {
  table: { width: "100%", borderCollapse: "separate", borderSpacing: 0, fontSize: 13 },
  th: {
    textAlign: "left", padding: "12px 16px", fontWeight: 700, color: C.textMed,
    fontSize: 11, textTransform: "uppercase", letterSpacing: 0.8,
    background: "linear-gradient(180deg, #F8FAFC, #F1F5F9)",
    borderBottom: `2px solid ${C.border}`, position: "sticky", top: 0, whiteSpace: "nowrap",
  },
  td: {
    padding: "12px 16px", borderBottom: `1px solid ${C.borderLight}`, transition: "all 0.15s",
  },
};

export const reportingGlobalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  .rpt-wrap { font-family: 'Inter', sans-serif; font-size: 14px; color: ${C.text}; }
  .rpt-wrap * { box-sizing: border-box; }
  @keyframes rptFadeIn { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
  .rpt-fade { animation: rptFadeIn 0.4s ease both; }
  .rpt-lift { transition: transform 0.2s, box-shadow 0.2s; }
  .rpt-lift:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(15,23,42,0.1); }
  .rpt-row { transition: all 0.15s; }
  .rpt-row:hover { background: linear-gradient(90deg, #f0fdfa 0%, #FFFFFF 100%) !important; }
  .rpt-wrap ::-webkit-scrollbar { width: 6px; height: 6px; }
  .rpt-wrap ::-webkit-scrollbar-track { background: transparent; }
  .rpt-wrap ::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 3px; }
`;
